import { makeStyles } from "@material-ui/core/styles";
import backgroungImage from "../../../assets/landingpage_shutterstock_1187511808-blur.jpg";

const useStyles = makeStyles((theme) => ({
  resendLink: {
    fontSize: "inherit",
    color: "#2352D0",
    cursor: "pointer",
    "&resendLink::hover": {
      textDecoration: "underline",
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    fontSize: "1.5em"
  },
  applogo: {
    opacity: 1,
    paddingRight: "2em",
    paddingTop: "1em",
    cursor: "pointer",
    float: "right",
    height: "2vw",
    minHeight: 35,
  },
  loginFormGrid: {
    minHeight: 300,
    // paddingLeft: "10em",
    // marginTop: "9vh",
    [theme.breakpoints.up("md")]: {
      padding: "5em",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "1em",
    },
    height: "100vh",
  },
  landingPageContainer: {
    background: `transparent url(${backgroungImage}) 30% 60% no-repeat`,
    color: "#FFFFFF",
    backgroundSize: "150%",
  },
  loginTitle: {
    [theme.breakpoints.up('md')]: {
      fontWeight: "bold",
      fontSize: "3em"
    },
    [theme.breakpoints.down('sm')]: {
      fontWeight: "bold",
    }
  },
  loginText: {
    color: "#FFF",
  },
  loginBox: {
    display: "flex",
    justifyContent: "center",
  },
  loginLink: {
    fontSize: "1.2em",
    color: "inherit",
    cursor: "pointer"
  },
  loginRow: {
    paddingBottom: "1em"
  },
  loginCard: {
    [theme.breakpoints.up('md')]: {
      paddingTop: "3em",
      paddingLeft: "7em",
      paddingRight: "7em",
      paddingBottom: "1em",
      maxWidth: "700px",
      marginRight: "auto",
      marginLeft: "auto"
    },
    [theme.breakpoints.down('sm')]: {
      // minWidth: '300px',
      paddingTop: "3em",
      paddingLeft: "2em",
      paddingRight: "2em",
      paddingBottom: "1em",
      maxWidth: "700px",
      marginRight: "auto",
      marginLeft: "auto"
    }
  },
  loginContainer: {
    textAlign: "center",
    width: "100%",
    height: "100%"
  },
  registerDisclaimerContainer: {
    display: "flex",
    flexDirection: "row",
    textAlign: "left",
    width: "100%",
    marginTop: "1em"
  },
  registerDialogTitle: {
    fontWeight: "bold",
    fontSize: "1.5em"
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "black",
  },
  dialogActionsContainer: {
    textAlign: "center"
  },
  confirmButton: {
    marginRight: "2em"
  },
  dialogPaper: {
    maxHeight: "70vh",
    overflow: "scroll",
    padding: "2em",
    paddingBottom: "1.5em"
  },
  return: {
    // color: "transparent",
    backgroundColor: "transparent",
    border: "1px solid black",
    fontSize: "1.2em",
  },
}), { index: 999 });

export default useStyles;
